module.exports = __webpack_public_path__ + "static/media/map-reflect.b1939ab7.png";